import React, { useState } from "react";

const Calculator = ({toggleCalculator}) => {

   const [input, setInput] = useState("0");
   const [position, setPosition] = useState({ x: 300, y: 300 });
   const [dragging, setDragging] = useState(false);
   const [offset, setOffset] = useState({ x: 0, y: 0 });
  
    const handleButtonClick = (value) => {
      if (value === "ON/C") {
        setInput("0");
      } else if (value === "=") {
        try {
          const evaluatedInput = input.replace(/x/g, "*").replace(/÷/g, "/");
          setInput(eval(evaluatedInput).toString());
        } catch {
          setInput("Error");
        }
      } else if (value === "+/-") {
        setInput((prev) => (prev.startsWith("-") ? prev.slice(1) : `-${prev}`));
      } else {
        setInput((prev) => (prev === "0" ? value : prev + value));
      }
    };
  
    const buttons = [
      ["+/-", "√", "%", "÷"],
      ["MRC", "M-", "M+", "x"],
      ["7", "8", "9", "-"],
      ["4", "5", "6", "+"],
      ["1", "2", "3", ""],
      ["ON/C", "0", ".", "="],
    ];

    const handleMouseMove = (e) => {
      if (dragging) {
        setPosition({
          x: e.clientX - offset.x,
          y: e.clientY - offset.y,
        });
      }
    };
  
    const handleMouseUp = () => {
      setDragging(false);
    };
    const handleMouseDown = (e) => {
      setDragging(true);
      setOffset({
        x: e.clientX - position.x,
        y: e.clientY - position.y,
      });
    };
  

  return (
    <div
      className="relative-container"
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      style={{
        position: "absolute",
        top: "50px",
        left: "50px"
      }} >
      <div
        className="calc-position"
        style={{
          position: "absolute",
          top: position.y,
          left: position.x,
          cursor: "move",
        }}
      >
        <div
          className="calculator-container"
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          >
          <div className="calculator">
            <div className="calculator-header text-white text-center py-2">
              <h5>
                Calculator
                <span className="close-icon" onClick={toggleCalculator}>
                  ❌
                </span>
              </h5>
            </div>
            <div className="calculator-screen text-right">
              <span>{input}</span>
            </div>
            <div className="calculator-buttons">
              {buttons
                .slice(0, buttons.length - 1)
                .map((row, rowIndex) => (
                  <div
                    className="d-flex justify-content-between"
                    key={rowIndex}
                  >
                    {row.map((button, index) => (
                      <button
                        key={index}
                        className={`btn ${
                          [
                            "ON/C",
                            "+/-",
                            "√",
                            "%",
                            "÷",
                            "x",
                            "-",
                            "+",
                          ].includes(button)
                            ? "btn-danger"
                            : "btn-light"
                        }`}
                        onClick={() => handleButtonClick(button)}
                      >
                        {button}
                      </button>
                    ))}
                  </div>
                ))}
                <div className="d-flex justify-content-between align-items-start">
                      <button
                        className="btn btn-danger"
                        onClick={() => handleButtonClick("ON/C")}
                      >
                        ON/C
                      </button>
                      <button
                        className="btn btn-light"
                        onClick={() => handleButtonClick("0")}
                      >
                        0
                      </button>
                      <button
                        className="btn btn-light"
                        onClick={() => handleButtonClick(".")}
                      >
                        .
                      </button>
                      <button
                        className="btn btn-danger large-equals"
                        onClick={() => handleButtonClick("=")}
                      >
                        =
                      </button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calculator;
